// Front/src/priorityApi.js

import CONFIG from "./config"; // Import config.js
import axios from "axios";

const { API_URL } = CONFIG;

// Fixed `receive_all_relevant_tasks_with_info` (No `/external/`)
export async function receive_all_relevant_tasks_with_info(userId) {

    const storedUser = JSON.parse(localStorage.getItem("user"));
    const token = storedUser?.token;
    if (token == null) {
        return { error: "Invalid Token" };
    }

    // For debugging
    //console.log("token = ", token, "userId = ", userId);

    try {
        const response = await axios.get(`${API_URL}/api/get/allrelevant/${userId}`, {
            headers: {
                "Authorization": `Bearer ${token}`, // using the token
            },
            withCredentials: true,
        });
        return response;

    } catch (error) {
        // for debugging
        // console.error("Failed to get info for service from Priority web api:", error);
        return {
            error
        };
    }
}

// Fixed `receive_specific_task_with_info` (POST version)
export async function receive_specific_task_with_info(serviceCall) {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const token = storedUser?.token;
    if (token == null) {
        return { error: "Invalid Token" };
    }

    try {
        const response = await axios.post(
            `${API_URL}/api/get/specificservicecall`,
            serviceCall, // plain string body
            {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                withCredentials: true,
            }
        );
        return response;
    } catch (error) {
        return { error };
    }
}
